import { SearchInputProps } from "./types";
import { useSearchInput } from "./useSearchInput";
import { SearchInputContent } from "./SearchInputContent";
import { forwardRef } from "react";

export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      searchValue = "",
      onChangeInput,
      onEnter,
      onClickCancel,
      placeholder,
      withIcon,
      withCancelIcon,
      withReturnIcon,
      onClickReturn,
      focusTrigger,
      onFocus,
      ...props
    },
    ref
  ) => {
    const {
      value,
      inputRef = null,
      handleChange,
      handleEnter,
      handleCancel,
      handleFocus,
    } = useSearchInput({
      searchValue,
      focusTrigger,
      onEnter,
      onChangeInput,
      onClickCancel,
      onFocus,
      ref,
    });

    return (
      <SearchInputContent
        value={value}
        withIcon={withIcon}
        withCancelIcon={withCancelIcon}
        withReturnIcon={withReturnIcon}
        placeholder={placeholder}
        inputRef={inputRef}
        onEnter={handleEnter}
        onChange={handleChange}
        onCancel={handleCancel}
        onFocus={handleFocus}
        onClickReturn={onClickReturn}
        inputProps={props}
      />
    );
  }
);
